module.exports = "../images/cabin-4-person-2.jpg?v=61582b9";